import { render, staticRenderFns } from "./Create1.vue?vue&type=template&id=7744fa79"
import script from "./Create1.vue?vue&type=script&lang=js"
export * from "./Create1.vue?vue&type=script&lang=js"
import style0 from "./Create1.vue?vue&type=style&index=0&id=7744fa79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports